<template>
  <div class="animated fadeIn tonnage-zones">
    <b-row>
      <b-col cols="12">
        <filters
          @search="applyFilterHandler"
          :api-request-data="apiRequestData"
        />
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <timeseries-chart
          title="Vessel Count"
          :dates="zoneStats.dates"
          :values="zoneStats.counts"
          :export-types="exportTypes"
          @export="format => handleExport(format)"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <timeseries-chart
          title="Vessel DWT"
          :y-axis="{ titleText: 'Million DWT' }"
          :dates="zoneStats.dates"
          :values="zoneStats.dwt"
          :export-types="exportTypes"
          @export="format => handleExport(format)"
        />
      </b-col>
    </b-row>

    <export-modal
      v-model="csvModal.show"
      file-type="csv"
      :file-link="csvModal.link"
      :alert-text="csvModal.alertText"
    />
  </div>
</template>

<script>
import moment from "moment";
import getNested from "lodash-es/get";
import { mapActions } from "vuex";

import Filters from "../components/tonnagezones/Filters";
import TimeseriesChart from "../components/widgets/TimeseriesChart";
import { downloadAsFile } from "@/shared/download-utils";
import ExportModal from "../components/widgets/ExportModal";

export default {
  components: {
    ExportModal,
    TimeseriesChart,
    // TonnageZoneChart,
    Filters
  },
  data() {
    return {
      zoneStats: {
        dates: [],
        counts: [],
        dwt: []
      },

      filterParameters: {},
      apiRequestData: {},

      exportTypes: ["csv"],
      csvModal: {
        show: false,
        link: null,
        alertText: null
      }
    };
  },
  methods: {
    ...mapActions("api/tonnage", ["getTonnageBalanceZonesStats"]),

    async applyFilterHandler(filterParameters) {
      window.analytics.track("TonnageZoneLoad");
      this.filterParameters = filterParameters;
      let response = await this.getTonnageBalanceZonesStats(
        this.filterParameters
      );
      this.zoneStats = { dates: [], counts: [], dwt: [] };
      getNested(response, "data.tonnageZoneCounts", []).forEach(item => {
        this.zoneStats.dates.push(item.date);
        this.zoneStats.counts.push(item.vesselCount);
        this.zoneStats.dwt.push(item.vesselDwt);
      });

      this.apiRequestData = {
        tonnageBalanceZonesStats: response.requestData
      };
    },

    async handleExport(format) {
      window.analytics.track("TonnageZoneExport");
      let response = await this.getTonnageBalanceZonesStats({
        ...this.filterParameters,
        format
      });

      if (getNested(response, "data.csv")) {
        this.csvModal.link = response.data.csv;
        this.csvModal.alertText = null;
        this.csvModal.show = true;
      } else {
        const timestamp = moment().format("YYYY-MM-DD-HH-mm");
        downloadAsFile(response, `tonnage_zone_export_${timestamp}.${format}`);
      }
    }
  }
};
</script>

<style scoped>
.tonnage-zones >>> .card-content {
  min-height: 460px;
}
</style>
